import {
  evaluateCSNigo,
  evaluateLincolnNigo,
  evaluateNWNigo,
  evaluateNWUnderwritingNigo,
  evaluateOANigo,
  evaluateSecurianNigo,
  FundingPolicyType,
  nationwideUnderwritingForm,
} from '@shared';

export type NigoEvaluator = (form: PolicyFormSubmissionData, state?: string) => RuleResult[];

export interface GetNigoEvaluatorParams {
  policyType: FundingPolicyType | undefined;
  formId: string;
}

function getNigoEvaluator({ policyType, formId }: GetNigoEvaluatorParams): NigoEvaluator {
  // Default to application form for Nationwide as it has general rules
  if (!policyType) {
    return evaluateNWNigo;
  }
  if (
    policyType === FundingPolicyType.assetCare ||
    policyType === FundingPolicyType.jointAssetCare
  ) {
    return evaluateOANigo;
  }

  if (policyType === FundingPolicyType.careScoutCareAssurance) {
    return evaluateCSNigo;
  }

  if (
    policyType === FundingPolicyType.careMattersTwo ||
    policyType === FundingPolicyType.jointCareMatters
  ) {
    // Check if it's an underwriting form (Personal History Interview)
    if (formId === nationwideUnderwritingForm.formId) {
      return evaluateNWUnderwritingNigo;
    }
    return evaluateNWNigo;
  }
  if (policyType === FundingPolicyType.secureCareThree) {
    return evaluateSecurianNigo;
  }

  if (policyType === FundingPolicyType.moneyGuardFixedAdvantage) {
    return evaluateLincolnNigo;
  }

  // Default fallback - return Nationwide application rules
  console.warn(
    `[getNigoEvaluator] Unknown policy type: ${policyType}, defaulting to Nationwide application rules`,
  );
  return evaluateNWNigo;
}

export function evaluateNigoForPolicy(
  params: GetNigoEvaluatorParams & { formData: PolicyFormSubmissionData; state?: string },
): RuleResult[] {
  const { policyType, formId, formData, state } = params;
  const evaluator = getNigoEvaluator({ policyType, formId });
  return evaluator(formData, state);
}
